module.exports = __webpack_public_path__ + "img/event_not.3372b2d0.png";